export default __webpack_public_path__ + "static/media/public.3a46ae35.jpg";